import React from 'react';
import { Box, Typography } from '@mui/material';

export const TranscriptPanel = ({ conversation, status }) => {
  if (!conversation?.length) {
    return (
      <Typography fontSize="20px" fontWeight="800" align="left" sx={{ textAlign: 'left', pl:"10px" }}>
        {status === 'initiated' ? 'No answer' : 'No record found'}
      </Typography>
    );
  }

  return (
    <>
      <Box display="flex" justifyContent="center" width="100%">
        <Typography fontWeight={700} width="50%">
          Recruiter:
        </Typography>
        <Typography fontWeight={700} width="50%">
          Lead:
        </Typography>
      </Box>

      {conversation.map(({ role, message }, index) => {
        const isAgent = (role ?? '').toLowerCase() === 'agent';
        return message ? (
          <Box
            key={index}
            mb={2}
            display="flex"
            justifyContent={isAgent ? 'left' : 'right'}
            textAlign="left"
            width="100%"
          >
            <Box width="49%">
              <Typography borderRadius="12px" p="5px" bgcolor={isAgent ? 'pink' : 'lightblue'}>
                {message}
              </Typography>
            </Box>
          </Box>
        ) : null;
      })}
    </>
  );
};
